import _ from "lodash";
import { makeCancellableAPIRequest } from "restAPI";
import {
  AnyaCancelDto,
  AnyaConversationRequestDto,
  AnyaEventDto,
  AnyaFeedbackDto,
  AnyaRequestDto,
  AnyaRetryDto,
} from "types/anya";

const AnyaAPI = {
  getAnyaAssistant(data: AnyaRequestDto) {
    return makeCancellableAPIRequest<AnyaRequestDto>(
      "POST",
      "/api/ai/assistant",
      {
        data,
      },
    );
  },
  storeFeedback(conversationId: string, queryParams: AnyaFeedbackDto) {
    const queryParamsString = new URLSearchParams(
      _.omitBy(queryParams, _.isNil),
    );
    return makeCancellableAPIRequest<AnyaFeedbackDto>(
      "PUT",
      `/api/ai/assistant/conversations/${conversationId}/feedback?${queryParamsString}`,
    );
  },
  getAnyaConversations(params?: {
    excludeFindingRemediations?: boolean;
    widgetId?: string;
  }) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/ai/assistant/conversations/list",
      {
        params,
      },
    );
  },
  getAnyaConversationMessages(params: AnyaConversationRequestDto) {
    return makeCancellableAPIRequest(
      "GET",
      `/api/ai/assistant/conversations/${params.conversationId}`,
      {
        params,
      },
    );
  },
  deleteAnyaConversationMessages(conversationId: string) {
    return makeCancellableAPIRequest(
      "DELETE",
      `/api/ai/assistant/conversations/${conversationId}`,
    );
  },
  sendConfirmation(data: AnyaEventDto) {
    return makeCancellableAPIRequest("POST", "/api/ai/assistant/event", {
      data: {
        event: data.event,
        requestId: data.requestId,
        conversationId: data.conversationId,
      },
    });
  },
  retryRequest(data: AnyaRetryDto) {
    return makeCancellableAPIRequest<AnyaRetryDto>(
      "POST",
      "/api/ai/assistant/retry",
      {
        data,
      },
    );
  },
  cancelRequest(data: AnyaCancelDto) {
    return makeCancellableAPIRequest<AnyaCancelDto>(
      "PUT",
      "/api/ai/assistant/cancel",
      {
        data,
      },
    );
  },
  getAnyaMessage(params: { conversationId: string; messageId: string }) {
    return makeCancellableAPIRequest(
      "GET",
      `/api/ai/assistant/message/${params.conversationId}/${params.messageId}`,
    );
  },
  storeWidgetData(params: {
    conversationId: string;
    messageId: string;
    widgetId: string;
    apiKey: string;
    data: unknown;
  }) {
    return makeCancellableAPIRequest(
      "POST",
      `/api/ai/assistant/store/widget/${params.conversationId}/${params.messageId}`,
      {
        data: {
          widgetId: params.widgetId,
          apiId: params.apiKey,
          data: params.data,
        },
      },
    );
  },
};

export default AnyaAPI;
